import AsyncComponent from "components/async-component";
import React from "react";

const ResetPasswordPage = () => {
    return (
        <div className="rui-main">
            <div className="rui-sign align-items-center justify-content-center">
                <AsyncComponent component={() => import("./content")} />
            </div>
        </div>
    );
};

export default ResetPasswordPage;
